import { forwardRef, Fragment, useEffect, useState } from "react"
import { PickerHeader, PickerPopupStyle } from "./styled"
import { Picker } from "antd-mobile"
import { StyledPortionInput } from "../PortionInput/styled"
import { IEdamaUnit } from "model/food/types/edama.types"

export interface Iprops {
  value: string
  onChange: (unitName: string) => void
  options: IEdamaUnit[]
}

type Ref = HTMLInputElement

const UnitsWheelPicker = forwardRef<Ref, Iprops>((props, ref) => {
  const { value, options, onChange } = props
  const [localValue, setLocalValue] = useState(value)
  const [pickerVisible, setPickerVisible] = useState(false)

  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value)
    }
  }, [value])

  const onUnitChange = (value: string) => {
    setLocalValue(value)
    onChange(value)
  }

  const columns = options.map((option) => {
    return {
      label: option.label,
      value: option.label,
    }
  })

  return (
    <Fragment>
      <PickerPopupStyle />
      <Picker
        cancelText=""
        confirmText="Done"
        popupClassName="picker-popup"
        title={<PickerHeader />}
        visible={pickerVisible}
        onClose={() => {
          setPickerVisible(false)
        }}
        columns={[columns]}
        onConfirm={(value) => {
          onUnitChange(value[0] as string)
        }}
        value={[value]}
        onSelect={(value) => {
          setLocalValue(value[0] as string)
        }}
      />

      <StyledPortionInput
        ref={ref}
        value={value}
        readOnly
        onClick={() => setPickerVisible(true)}
      />
    </Fragment>
  )
})

export default UnitsWheelPicker
